import { render, staticRenderFns } from "./VectorMatchTest.vue?vue&type=template&id=b8db71d8&scoped=true"
import script from "./VectorMatchTest.vue?vue&type=script&lang=js"
export * from "./VectorMatchTest.vue?vue&type=script&lang=js"
import style0 from "./VectorMatchTest.vue?vue&type=style&index=0&id=b8db71d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8db71d8",
  null
  
)

export default component.exports